import {
  MULTIMAXI_SPLIT_HEADER_HEIGHT,
  MULTIMAXI_SPLIT_LOADBAR_HEIGHT,
  MULTIMAXI_SPLIT_MIN_ROW_HEIGHT,
} from '../constants'

export function calculateAmountOfPassagesPerStop({
  amountOfStopsInCol = 0,
  otherHeightToSubtract = 0,
}) {
  const viewportHeight = document.body.clientHeight
  const totalHeightOfHeaders =
    amountOfStopsInCol *
    (MULTIMAXI_SPLIT_HEADER_HEIGHT + MULTIMAXI_SPLIT_LOADBAR_HEIGHT)

  const totalAmountOfPassages =
    (viewportHeight - totalHeightOfHeaders - otherHeightToSubtract) /
    MULTIMAXI_SPLIT_MIN_ROW_HEIGHT

  return Math.floor(totalAmountOfPassages / amountOfStopsInCol)
}

export function getStopsByColumns(stops) {
  const amountOfStops = stops.length
  const amountOfCol1ItemsByAmountOfStops = [1, 1, 1, 2, 2, 3, 3, 4]

  return {
    c1() {
      return amountOfStops > 0
        ? stops.slice(0, amountOfCol1ItemsByAmountOfStops[amountOfStops - 1])
        : []
    },
    c2() {
      return amountOfStops > 0
        ? stops.slice(
            amountOfCol1ItemsByAmountOfStops[amountOfStops - 1],
            amountOfStops,
          )
        : []
    },
  }
}
